import Vue from 'vue'
import VueCryptojs from 'vue-cryptojs'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import LoadScript from 'vue-plugin-load-script'
import VueTypedJs from "vue-typed-js";
// import keycloak from './keycloak.js'

// http://localhost:3001 'http://192.168.200.132:5000' '/map-back-end/'
window.axios = axios
// axios.defaults.baseURL = 'http://localhost:7400'
axios.defaults.baseURL = '/map-back-end/'
axios.defaults.timeout = 90000

// console.log(window.location.origin)
// Initialize Keycloak and then mount the app

Vue.use(LoadScript)
Vue.use(VueCryptojs)
Vue.use(VueTypedJs)
Vue.config.productionTip = false
export const bus = new Vue()
  new Vue({
    router,
    store,
    axios,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
  